export default __webpack_public_path__ + "static/media/david9.55a006c8.jpg";